import { templatesClient } from "lib/clients";
import useSWR from "swr";
import { Pack } from "lib/types";

const fetcher = async () => {
  try {
    const { data } = await templatesClient.getTemplates();
    return data;
  } catch (err) {
    throw err;
  }
}

export const useTemplates = () => {
  const { data, error, isValidating, mutate } = useSWR<Pack[]>('/v1/templates', fetcher, { revalidateOnFocus: false });

  return {
    data,
    isValidating,
    isLoading: !data && !error,
    error,
    mutate,
  };
};
